import { ResultData } from 'src/app/_models/ResultData';



import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { HeaderService } from './header.service';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageInfoService {
  aHeader = undefined



  constructor(
    private http: HttpClient,
    private headerService:HeaderService) { }
    getAll():Observable<ResultData>{
      return this.http.get<ResultData>(`${environment.apiUrl}/sentMessage/all/`,{headers:this.headerService.bearerJsonHeaders()})
    }

    getAllByUser(levelId:number):Observable<ResultData>{
      return this.http.get<ResultData>(`${environment.apiUrl}/sentMessage/allByUser/${levelId}`,{headers:this.headerService.bearerJsonHeaders()})

    }


}
